import { render } from "./message-reference.vue?vue&type=template&id=06f7d624&scoped=true&ts=true"
import script from "./message-reference.vue?vue&type=script&lang=ts"
export * from "./message-reference.vue?vue&type=script&lang=ts"

import "./message-reference.vue?vue&type=style&index=0&id=06f7d624&lang=scss&scoped=true"

import exportComponent from "D:\\phpstudy_pro\\WWW\\tengxunshipin\\chat-example\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f7d624"]])

export default __exports__